import axios, { AxiosResponse } from 'axios';

const apiUrl = process.env.REACT_APP_API_URL;
const reportAPI = {
	fetchCustomersCount: () => {
		return axios.get(`${apiUrl}/reports/customers/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchUserActivities: (fromDate: string, toDate: string) => {
		return axios.get(`${apiUrl}/reports/user-activities/from/${fromDate}/to/${toDate}.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchPoliciesCount: () => {
		return axios.get(`${apiUrl}/reports/policies/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchPolicies: () => {
		return axios.get(`${apiUrl}/reports/policies.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchUnmailedPoliciesCount: () => {
		return axios.get(`${apiUrl}/reports/unmailed-policies/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchUnmailedPolicies: () => {
		return axios.get(`${apiUrl}/reports/unmailed-policies.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchFailedPaymentsCount: () => {
		return axios.get(`${apiUrl}/reports/failed-payments/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchFailedPayments: () => {
		return axios.get(`${apiUrl}/reports/failed-payments.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchExpiringPoliciesCount: () => {
		return axios.get(`${apiUrl}/reports/expiring-policies/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchExpiringPolicies: () => {
		return axios.get(`${apiUrl}/reports/expiring-policies.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchMissingBeneficiaryFormsCount: () => {
		return axios.get(`${apiUrl}/reports/missing-beneficiary-forms/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchCustomersMissingBeneficiaryForms: () => {
		return axios.get(`${apiUrl}/reports/missing-beneficiary-forms/customers.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchBouncedEmailsCount: () => {
		return axios.get(`${apiUrl}/reports/bounced-emails/count.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchBouncedEmails: () => {
		return axios.get(`${apiUrl}/reports/bounced-emails.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	resolveBouncedEmail: (id: string) => {
		return axios.post(`${apiUrl}/reports/bounced-emails/${id}/resolve`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchFinancialExport: (fromDate: string, toDate: string) => {
		return axios.get(`${apiUrl}/reports/financial-export/from/${fromDate}/to/${toDate}.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
	fetchReferralReport: () => {
		return axios.get(`${apiUrl}/reports/referrals.json`)
			.then((resp: AxiosResponse) => resp.data);
	},
};

export default reportAPI;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/report/reportAPI.ts